// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// State
import { NgxsModule } from '@ngxs/store';
import { IntelligenceState } from './state/intelligence.state';
import { InboxState } from './inbox/state/inbox.state';
import { ImportState } from './import-order/state/import.state';
// Module
import { IntelligenceRoutingModule } from './intelligence-routing.module';
import { CvComponentLibraryModule } from '@cv-invision/cv.component-library.ux';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { AgGridModule } from 'ag-grid-angular';
import {QualityModule} from './quality/quality.module';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
// Service
import { ComponentFactoryResolverService, HttpCoreModule } from '@cv-invision/core';
import { OrderActivityService } from './inbox/service/order-activity.service';
import { DialogService } from 'primeng/dynamicdialog';
// Components
import { InboxComponent } from './inbox/inbox.component';
import { CreateOrderComponent } from './create-order/create-order.component';
import { ImportOrderComponent } from './import-order/import-order.component';
import { CustomActionCellComponent } from './inbox/custom-action-cell/custom-action-cell.component';
import { CustomIDCellComponent } from './inbox/custom-id-cell/custom-id-cell.component';
import { OrderContentDetailComponent } from './inbox/order-content-detail/order-content-detail.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ReSubmitOrderComponent } from './inbox/resubmit-order/resubmit-order.component';
import { InboxHeaderComponent } from './inbox/header/inbox-header.component';
import { CustomStatusCellComponent } from './inbox/custom-status-cell/custom-status-cell.component';
import { CustomStatusImportCellComponent } from './import-order/custom-status-cell/custom-status-cell.component';
import { ConfirmationImportModalComponent } from './import-order/confirmation-import-modal/confirmation-import-modal.component';
import { CustomFlagsCellComponent } from './inbox/custom-flags-cell/custom-flags-cell.component';
import { CustomSmartqcCellComponent } from './inbox/custom-smartqc-cell/custom-smartqc-cell.component';
import { CustomTooltipFlagCellComponent } from './inbox/custom-tooltip-cell/custom-tooltip-cell.component';
import { IntelligenceComponent } from "./intelligence.component";
import { OrderActivitDialogComponent } from './inbox/dialogs/order-activity/order-activity-dialog.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IntelligenceRoutingModule,
		CvComponentLibraryModule,
		NgxsModule.forFeature([IntelligenceState, InboxState, ImportState]),
		QualityModule,
		// Third modules
		NgbDatepickerModule,
		AgGridModule.withComponents([]),
		HttpCoreModule,
		ButtonModule,
		TableModule
	],
	declarations: [
		InboxComponent,
		InboxHeaderComponent,
		CreateOrderComponent,
		ImportOrderComponent,
		OrderContentDetailComponent,
		DashboardComponent,
		// Grid Custom Cells
		CustomActionCellComponent,
		CustomIDCellComponent,
		ReSubmitOrderComponent,
		CustomStatusCellComponent,
		CustomStatusImportCellComponent,
		ConfirmationImportModalComponent,
		CustomFlagsCellComponent,
		CustomTooltipFlagCellComponent,
		CustomSmartqcCellComponent,
		IntelligenceComponent,
		OrderActivitDialogComponent
	],
	entryComponents: [
		InboxHeaderComponent,
		// Grid Custom Cells
		CustomTooltipFlagCellComponent,
		CustomFlagsCellComponent,
		CustomActionCellComponent,
		CustomSmartqcCellComponent,
		CustomIDCellComponent,
		CustomStatusCellComponent,
		CustomStatusImportCellComponent,
		OrderContentDetailComponent,
		ReSubmitOrderComponent,
		ConfirmationImportModalComponent
	],
	providers: [
		ComponentFactoryResolverService,
		OrderActivityService,
		DialogService
	]
})
export class IntelligenceModule {}
